import { render, staticRenderFns } from "./EditLovSize.vue?vue&type=template&id=4e31ced2"
import script from "./EditLovSize.vue?vue&type=script&lang=js"
export * from "./EditLovSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports